import {
  digitsOnly,
  isValidAbaRoutingChecksum,
  result,
  stringify,
} from '../shared';

export const key = 'us_bank_routing_number';

export const meta = {
  label: 'US Bank Routing Number',
  sensitive: false,
  allowed_contact_types: ['string', 'int', 'secret'],
  allowed_form_types: ['Text'],
};

export function validate(value) {
  const raw = stringify(value);
  if (!raw) {
    return result(false, '', 'US bank routing number is required');
  }
  if (/[a-z]/i.test(raw)) {
    return result(false, raw, 'US bank routing number cannot contain letters');
  }

  const digits = digitsOnly(raw);
  if (!digits) {
    return result(false, '', 'US bank routing number is required');
  }
  if (digits.length !== 9) {
    return result(
      false,
      digits,
      `US bank routing number must be exactly 9 digits (got ${digits.length})`
    );
  }
  if (!isValidAbaRoutingChecksum(digits)) {
    return result(
      false,
      digits,
      'This routing number is not valid. Confirm the 9 digits on your check or bank statement.'
    );
  }
  return result(true, digits);
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : stringifyFallback(value);
}

function stringifyFallback(value) {
  return digitsOnly(value);
}

export function display(value) {
  return digitsOnly(value);
}

export function getInputProps() {
  return {
    mask: '#'.repeat(9),
    maxlength: 9,
    inputmode: 'numeric',
  };
}
